// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7d2c52e","721":"8b3d9776"}[chunkId] + ".chunk.js";
};